import React from "react";
import { rem } from "polished";
import styled from "styled-components";

import { IconStore } from "../../../../components/atoms";
import { device } from "../../../../utils/media-queries";

import { useDownloadAppLink } from "../../../../hooks/use-download-app-link";
import { Heading1, Panel, Paragraph } from "../../atoms";

import phone from "./phone.webp";
import LazyLoad from "react-lazy-load";

const PanelStyled = styled(Panel)`
  background-color: ${({ theme }) => theme.colours.ruubyPink};
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0;
  cursor: pointer;
  padding-top: ${rem("30px")};

  @media ${device.tablet} {
    flex-direction: row-reverse;
    justify-content: center;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${device.tablet} {
    margin-left: ${rem("61px")};
    align-items: flex-start;
  }
`;

const Heading = styled(Heading1)`
  text-align: center;
  margin: 0;
  width: ${rem("225px")};

  @media ${device.tablet} {
    width: ${rem("430px")};
    text-align: left;
  }
`;

const Intro = styled(Paragraph)`
  text-align: center;
  margin: ${rem("20px")} 0 0 0;
  font-weight: bold;
  width: ${rem("225px")};
  font-size: ${({ theme }) => theme.type.sizes.size16};

  @media ${device.tablet} {
    font-size: ${({ theme }) => theme.type.sizes.size20};
    width: ${rem("300px")};
    text-align: left;
  }
`;

const IconsContainer = styled.div`
  margin-top: ${rem("24px")};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const IconStoreStyled = styled(IconStore)`
  height: ${rem("39px")};

  :not(:first-child) {
    margin-left: ${rem("7px")};
  }

  :not(:last-child) {
    margin-right: ${rem("7px")};
  }

  @media ${device.tablet} {
    height: ${rem("48px")};
  }
`;

const PhoneImage = styled.img`
  margin-top: ${rem("20px")};
  width: ${rem("200px")};
  height: ${rem("306px")};

  @media ${device.tablet} {
    margin-top: 0;
  }
`;

export const DownloadAppPanel = (): JSX.Element => {
  const { QrModal, handleClickDownloadApp } = useDownloadAppLink();

  return (
    <>
      <PanelStyled onClick={handleClickDownloadApp}>
        <div>
          <ContentContainer>
            <Heading>Download the Ruuby App</Heading>
            <Intro>
              Browse, book and manage your treatments straight from your phone.
            </Intro>
            <IconsContainer>
              <IconStoreStyled type="ios" />
              <IconStoreStyled type="android" />
            </IconsContainer>
          </ContentContainer>
        </div>
        <LazyLoad offset={200}>
          <PhoneImage src={phone} />
        </LazyLoad>
      </PanelStyled>
      <QrModal />
    </>
  );
};
